import { EVENTS } from '../BingMap.constants';

let map;
const pinDragState = {
  distX: 0, distY: 0, pin: null, isMoved: false,
};

const mapDragState = {
  distX: 0, distY: 0, dragging: false, dragged: false,
};

/** Sets the start position of the map drag movement. */
const onMapDown = (e) => {
  e.preventDefault();
  const evt = e.type === EVENTS.TOUCHSTART ? e.changedTouches[0] : e;

  mapDragState.distX = evt.clientX;
  mapDragState.distY = evt.clientY;
  mapDragState.dragging = true;
};

/** Sets the start position of the pin drag movement. */
const onPinDown = (pin) => (e) => {
  e.stopPropagation();

  pinDragState.pin = pin;

  const evt = e.type === EVENTS.TOUCHSTART ? e.changedTouches[0] : e;

  pinDragState.distX = Math.abs(evt.clientX);
  pinDragState.distY = Math.abs(evt.clientY);
};

const onUp = (layer, handleAddPin, setLocation, handleRemoveFocus) => (e) => {
  e.preventDefault();
  const { pin, isMoved } = pinDragState;
  if (pin) {
    const { Microsoft } = window;
    const { index, element } = pin;
    // Re-enable the "pointerEvents" on the pin element.
    // If this is not enabled, then the element won't move.
    element.style.pointerEvents = 'initial';

    // Get the updated lat/lon values for pin from the new pin location.
    const p = new Microsoft.Maps.Point(element.offsetLeft, element.offsetTop);
    const newPinLocation = map.tryPixelToLocation(p, Microsoft.Maps.PixelReference.control);
    if (isMoved) {
      setLocation(index, newPinLocation);
      e.stopPropagation();
    }

    pinDragState.distX = 0;
    pinDragState.distY = 0;
    pinDragState.pin = null;
    pinDragState.isMoved = false;
  } else {
    if (mapDragState.dragging && !mapDragState.dragged) {
      if (layer.getIsComplex()) handleAddPin(e, layer.pushpins.length);
      handleRemoveFocus();
    }
    mapDragState.dragging = false;
    mapDragState.dragged = false;
  }
};

/** Updates the position of the map or pin. */
const onMove = (layer) => (e) => {
  e.preventDefault();
  const evt = e.type === EVENTS.TOUCHMOVE ? e.changedTouches[0] : e;
  const { pin } = pinDragState;
  if (pin) {
    const { element } = pin;
    // Update top/left directly in the dom element:
    const x = evt.clientX - pinDragState.distX;
    const y = evt.clientY - pinDragState.distY;
    pinDragState.distX = Math.abs(evt.clientX);
    pinDragState.distY = Math.abs(evt.clientY);
    element.style.left = `${element.offsetLeft + x}px`;
    element.style.top = `${element.offsetTop + y}px`;

    // Disable pointer events on the pin to disable click event from being triggered
    element.style.pointerEvents = 'none';
    pinDragState.isMoved = true;
  } else if (mapDragState.dragging === true) {
    mapDragState.dragged = true;

    // Create a point object for the disctance moved on the map.
    const point = new window.Microsoft.Maps.Point((mapDragState.distX - evt.clientX), (mapDragState.distY - evt.clientY));
    mapDragState.distX = evt.clientX;
    mapDragState.distY = evt.clientY;

    // Get the updated lat/lon values for map center from the distanced moved.
    const newCenter = map.tryPixelToLocation(point);
    map.setView({ center: newCenter });
    layer.updatePositions();
  }
};

/** Add drag events to pin element */
export const addDragEventsToPin = (pin) => {
  pin.element.addEventListener(EVENTS.MOUSEDOWN, onPinDown(pin));
  pin.element.addEventListener(EVENTS.TOUCHSTART, onPinDown(pin));
};

/** Add mouse events to layer container dragging pin and map, and adding pins */
export const addEventsToLayer = (layer, handleAddPin, updateLocation, handleRemoveFocus) => {
  // Add touch events to layer container to enable dragging map and pin on touch devices.
  layer.container.addEventListener(EVENTS.TOUCHSTART, onMapDown);
  layer.container.addEventListener(EVENTS.TOUCHMOVE, onMove(layer));
  layer.container.addEventListener(EVENTS.TOUCHEND, onUp(layer, handleAddPin, updateLocation, handleRemoveFocus), true);

  // Add mouse events to layer container to enable dragging map and pin.
  layer.container.addEventListener(EVENTS.MOUSEDOWN, onMapDown);
  layer.container.addEventListener(EVENTS.MOUSEMOVE, onMove(layer));
  layer.container.addEventListener(EVENTS.MOUSEUP, onUp(layer, handleAddPin, updateLocation, handleRemoveFocus), true);
};

/** Set map object required for locating pins */
export const setMap = (layerMap) => {
  map = layerMap;
};
